/**
 * @generated SignedSource<<06894f3c975efaeeb957a0d63aeebede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetHasAccessQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetDailyPulseQuery" | "plusWidgetHighlightsQuery" | "plusWidgetHighlightsVariantQuery" | "plusWidgetNewsAgendaQuery">;
  readonly " $fragmentType": "plusWidgetHasAccessQuery";
};
export type plusWidgetHasAccessQuery$key = {
  readonly " $data"?: plusWidgetHasAccessQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetHasAccessQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "queueName",
    "variableName": "highlightQueueName"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetHasAccessQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetDailyPulseQuery"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsQuery"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsVariantQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetNewsAgendaQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a2ba9ae1e91d32497eac118fe9d8660c";

export default node;
